import * as angular from 'angular';

import * as utils from '../../utils';

interface IMenuScope extends angular.IScope {
    verticalOffset: number;
}

class MenuDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';
    readonly scope = {
        verticalOffset: '=?'
    };

    readonly template = `
        <div
            class="fc-menu dropdown-pane"
            data-dropdown="true"
            data-auto-focus="true"
            data-close-on-click="true"
            data-position="bottom"
            data-alignment="right"
            data-v-offset="{{ verticalOffset }}"
            ng-transclude
        ></div>
    `;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(scope: IMenuScope): void {
        scope.verticalOffset = utils.isNumber(scope.verticalOffset) ? scope.verticalOffset : 10;
    }
}

const MenuDirectiveFactory: angular.IDirectiveFactory = () => new MenuDirective();

export { MenuDirectiveFactory };
